(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('ShippingCompanyService', ShippingCompanyService)

    /** @ngInject */
    function ShippingCompanyService(HttpService) {
        const ShippingCompanyService = {
            getAll: getAll,
            getAllByType: getAllByType,
            getAllShippingTypes: getAllShippingTypes,
            getByUnitId: getByUnitId
        }

        return ShippingCompanyService;

        function getAll() {
            return HttpService.get('/shipping-companies/resumed');
        }

        function getAllByType(shippingTypeId) {
            return HttpService.get(`/shipping-companies/shipping-types/${shippingTypeId}`);
        }

        function getAllShippingTypes() {
            return HttpService.get('/shipping-types/resumed');
        }

        function getByUnitId(unitId) {
            return HttpService.get(`/shipping-companies/unit/${unitId}`);
        }
    }
}());